// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"561ecf24","453":"e549d8d3","455":"0a5688d0"}[chunkId] + ".chunk.js";
};